import React from "react"
import { useFormContext } from "react-hook-form"
import { Anchor, Alert, Flex, List } from "@mantine/core"

import { Icon } from "@/components"
import { useStyles } from "@/components/QuorumFormProvider/ErrorSummary/ErrorSummary.styles"
import { formatErrors } from "@/components/QuorumFormProvider/ErrorSummary/helpers"

interface ErrorSummaryProps {
    noLeftEmptySpace?: boolean
}

export const ErrorSummary = (props: ErrorSummaryProps) => {
    const { classes } = useStyles()
    const { formState } = useFormContext()
    const errors = formatErrors(formState.errors).filter((error) => error.message)

    if (!errors.length) {
        return null
    }

    return (
        <Flex className={classes.container}>
            {!props.noLeftEmptySpace && <Flex className={classes.placeholder} />}

            <Flex className={classes.summary}>
                <Alert
                    className={classes.alert}
                    icon={<Icon icon="exclamation-circle" iconFamily="fas" />}
                    title={`The form has ${errors.length} error${errors.length > 1 ? "s" : ""}:`}
                    color="red"
                >
                    <List>
                        {errors.map((error, index) => (
                            <List.Item className={classes.item} key={`${error.fieldName}-${error.validator}-${index}`}>
                                <Anchor
                                    component="button"
                                    type="button"
                                    onClick={() => {
                                        document.getElementById(error.fieldName).scrollIntoView()
                                    }}
                                    className={classes.link}
                                >
                                    {error.message}
                                </Anchor>
                            </List.Item>
                        ))}
                    </List>
                </Alert>
            </Flex>
        </Flex>
    )
}
